<template>
    <div>
        <Guard :hideFor="['shop_owner']">
            <button class="btn btn-primary btn-sm mr-3" @click="openDeviceModal">{{$t('COMMON.mangeImages')}}</button>
        </Guard>
        <functional-modal
            :showModal="deviceModal"
            :title="$t('COMMON.addPicture')"
            :big="true"
            :showClose="false"
            >
                <div :class="['col-12', 'mt-5']" slot="body">
                    <shop-devices-form :devices="getShopDevices" :context="context" @close="closeDeviceModal"></shop-devices-form>
                </div>
        </functional-modal>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import ShopDevicesForm from './ShopDevicesForm.vue';
import FunctionalModal from '../../../components/Shared/Modal/FunctionalModal.vue';
import _ from 'underscore';

export default {
    name: 'ShopDevices',
    data(){
        return {
            deviceModal: false,
        }
    },
    components: {
        ShopDevicesForm,
        FunctionalModal
    },
    props: {
        context: {
            type: String,
            default: '',
        },
        reloadData: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters({
            getShopDevices: 'getShopDevices',
            currentShop: 'currentShop',
            currentSetup: 'currentSetup',
            defaultSetup: 'defaultSetup',
            getCurrentShopFormIsValid: 'getCurrentShopFormIsValid',
            getUser: 'getUser',
        }),
        setupData: {
            get() {
                return this.currentSetup;
            },
            // setter
            set(setup) {
                this.UpdateCurrentSetup(setup);
            }
        },
        shop: {
            get() {
                return this.currentShop;
            },
            set(shop) {
                this.CurrentShop(shop);
            }
        }
    },
    methods: {
        ...mapActions([
            'GetShopDevices',
            'UpdateShopDevices',
            'GetShopById',
            'SaveShop',
            'GetShopById',
            'CurrentShop',
            'GetSetupDataById',
            'SaveSetupData',
            'GetDefaultSetup',
            'UpdateCurrentSetup',
            'SaveShopRegistrationState',
            'updateShopAsync',
            'SaveBasketData',
            'GetBasketData',
            'GetEnvConfigData',
            'SaveEnvConfigData',
            'AddShopToUser',
            'DelShopFromUser',
            'UpdateShop'
        ]),

        saveShopDevices() {
            this.UpdateShopDevices(this.getShopDevices);
            this.closeDeviceModal()
        },
        async updateShop(){
          const { store } = await this.UpdateShop({ store: this.shop, setup: this.setupData, envs: this.envConfigs });
          return store;
        },
        setEnvByKeyName(envKey, envValue) {
            console.log({envKey, envValue});
            this.envConfigs.forEach(({ serviceName, envs }, serviceIndex) => {
                envs.forEach(({ key, value }, envIndex) => {
                if (envKey === key) {
                    this.envConfigs[serviceIndex].envs[envIndex].value = envValue;
                }
                });
            });
        },
        prepareLink(link){
            const imageLink = link.substring(link.indexOf("/filestorage"), link.length)
            return `http://nginx${imageLink}`
        },
        closeDeviceModal() {
            this.UpdateShopDevices(this.getShopDevices);
            this.deviceModal = false

            this.getShopDevices.forEach(item => {
                if(item.symbol == "receipt_banner"){
                    if(item.link){
                        this.setEnvByKeyName("receipt_ad_graphic", this.prepareLink(item.link))
                    }else {
                        const mapShopsUsers = {
                            "hWk74opQh" : "./images/photosi.png", //phptosi
                            "ix2-KTt8g" : "./images/photosi.png", // photosi gdo
                            "RItjooGGW": "./images/receiptAd1.jpg", // budni
                            "453T7bPzA": "./images/receiptAd1.jpg", // nordfoto
                            "13nR5hRIl": "./images/rossmann.png", // Rossmann
                            "rNabrAsHW": "./images/BIPA.png", //bipa
                            "HOdT93Fmp": "./images/standard-receipt.png", //allcop
                            "PrDutaYRg": "./images/hema.jpg", //hema
                            "zhaEtBCse": "./images/standard-receipt.png", // kanemtasu
                            "83AyqIUN": "./images/standard-receipt.png", // edeka
                            "default": "./images/standard-receipt.png", // default
                        }
                        const users = this.shop.users.map(u => u.id).filter(u => u !== "Hy7QrwLe7")
                        let envValue =  mapShopsUsers[users[0]] === undefined ? mapShopsUsers['default'] :  mapShopsUsers[users[0]]
                        this.setEnvByKeyName("receipt_ad_graphic", envValue)
                    }
                }
                if(item.symbol == "ds820"){
                    if(item.link){
                        this.setEnvByKeyName("device_shape_ds820", this.prepareLink(item.link))
                    }
                }
                if(item.symbol == "rs1"){
                    if(item.link){
                        this.setEnvByKeyName("device_shape_rs1", this.prepareLink(item.link))
                    }
                }
                if(item.symbol == "shop_icon"){
                    if(item.link){
                        this.shop.iconURL = item.link
                    }
                }
            })

            this.updateShop()
            .then(store =>{
                this.UpdateCurrentSetup(this.setupData);
                this.CurrentShop(store);
                this.$router.push({ name: 'shopsshow', params: { id: store.id } });
            })
            .catch(err => this.pending = false);
            this.$props.reloadData()
        },
        openDeviceModal(){
            this.deviceModal = true
        },
        async selected(data){
          const shop = _.clone(data);
          let config;

          if(data.id) {
            delete shop.id;
            if(!shop.workDays) {
              shop.workDays = [];
            }
          }
          config = await this.GetSetupDataById(shop.setupID);
       

          this.envConfigs =  await this.GetEnvConfigData({ context: data.id, role: "admin" });
          this.CurrentShop(shop);
          this.UpdateCurrentSetup(_.extend(this.defaultSetup, config));
        },
    },
    async created () {
        this.GetShopDevices(this.context);
        const defaultSetup = await this.GetDefaultSetup();
        this.envConfigs =  await this.GetEnvConfigData({ context: this.$props.context, role: "admin" });

        try{
            const shop = await this.GetShopById(this.$props.context);
            this.selected(shop);
        } catch(err){
            console.log("Created error: ", err);
          //this.$router.replace({name: '404'});
        }
    },
}
</script>

<style lang="scss" scoped>
    div.modal-dialog {
        max-width: 40%;
    }
</style>
